import { Identifiable } from './identifiable';
import { BaseEntity } from './base-entity';
import { Contact } from './contact';

export class AssessmentComment implements Identifiable {
  id: string;
  comments: string;
  contact: Contact;
  owner: BaseEntity; // Survey
  deletedPersonnelRecord: BaseEntity;
}
